import { useState } from 'react';
import bookingService from 'components/Booking-new/services/BookingService';

export const useLocationTimeSlots = (locationCode, serviceCode) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [slotsPerLocation, setSlotsPerLocation] = useState({});
  const [slotsFetched, setSlotsFetched] = useState(false);

  // fetch function that can be called to trigger data fetch/re-fetch
  const fetchSlots = async () => {
    setLoading(true);
    setError(null);

    let slots = {};

    try {
      const response = await bookingService.getTimePerLocationV3Slots(locationCode, serviceCode);

      if (response.error !== null) {
        slots[locationCode] = { error: response.error, slots: {} };
      } else {
        // find the correct location within the data array
        const locationData = response.data.find(
          location => location.location === locationCode && location.service === serviceCode,
        );
        if (locationData && locationData.slots) {
          let sortedSlots = Object.entries(locationData.slots)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .filter(entry => Array.isArray(entry[1]) && entry[1].length > 0);
          slots[locationCode] = { error: null, slots: Object.fromEntries(sortedSlots) };
        } else {
          // if there is no data or slots for the location
          slots[locationCode] = {
            error: `No slots found for location: ${locationCode} and service: ${serviceCode}`,
            slots: {},
          };
        }
      }
    } catch (err) {
      slots[locationCode] = { error: err.message, slots: {} };
    }
    setSlotsPerLocation(slots[locationCode] ? slots[locationCode].slots : {});
    setSlotsFetched(true);
    setLoading(false);
  };

  return { slotsPerLocation, loading, error, fetchSlots, slotsFetched };
};
